import React from "react";

// Custom bat silhouette SVG. Elegant, editorial — not costume-party.
export default function BatLogo({ size = 48, className = "", glow = true }) {
  return (
    <svg
      width={size}
      height={size * 0.55}
      viewBox="0 0 200 110"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={glow ? { filter: "drop-shadow(0 0 12px rgba(245,158,11,0.55))" } : undefined}
      aria-hidden="true"
    >
      <path
        d="M100 8 C 96 22, 90 30, 82 34 C 74 22, 60 12, 42 12 C 46 26, 44 38, 38 46 C 24 46, 12 54, 4 66 C 22 62, 40 68, 54 82 C 60 74, 70 68, 80 72 C 86 80, 92 92, 100 100 C 108 92, 114 80, 120 72 C 130 68, 140 74, 146 82 C 160 68, 178 62, 196 66 C 188 54, 176 46, 162 46 C 156 38, 154 26, 158 12 C 140 12, 126 22, 118 34 C 110 30, 104 22, 100 8 Z"
        fill="currentColor"
      />
    </svg>
  );
}
